import {takeLatest, all, AllEffect, ForkEffect} from 'redux-saga/effects';
import { Types } from '../ducks/user';
import { Types as CustomerTypes } from '../ducks/customer';
import sendPin, { SendPinAction } from './pin/send';
import validatePin, { ValidatePinAction } from './pin/validate';
import requestDebts, { RequestDebtsAction } from './debts/request';
import debtsPulling, { DebtsPullingAction } from './debts/pulling';
import searchAddressByZipcode, { SearchAddressAction } from './address/zipcode';
import paymentCard, { PaymentCardAction } from './payment/card';
import paymentPix, { PaymentPixAction } from './payment/pix';
import authorize, { AuthAction } from './customer/auth';
import requestTickets, { RequestTicketsAction } from './tickets';
import requestInvoice, { RequestInvoiceAction } from './tickets/invoice';
import sendMessage, { SendMessageAction } from './faq/sendMessage';
import auth, { AuthAction as AuthorizeAction } from './auth/login/auth';
import refresh, { RefreshAction } from './auth/login/refresh';
import getData, { GetDataAction } from './auth/login/data';
import sendPinRegisterDevice, { SendPinRegisterDeviceAction } from './registerDevice/send';
import validatePinRegisterDevice, { ValidatePinRegisterDeviceAction } from './registerDevice/validate';
import sendPinRegister, { SendPinRegisterAction } from './pin/sendRegister';
import validatePinRegister, { ValidatePinRegisterAction } from './pin/validateRegister';
import searchAddressByZipcodeAutomatic, {SearchAddressAction as SearchAddressActionAutomatic} from './address/automaticZipcode';
import validatePlate, { ValidatePlateAction } from './plate/validate';
import requestBrands, { RequestBrandsAction } from './vehicles/brands';
import requestCategories, { RequestCategoriesAction } from './vehicles/categories';
import requestModels, { RequestModelsAction } from './vehicles/models';
import requestYears, { RequestYearsAction } from './vehicles/years';
import createUser, { CreateUserAction } from './register/createUser';
import createCredentials, { CreateCredentialsAction } from './register/createCredentials';
import validatePinForgot, { ValidatePinForgotAction } from './recoveryPassword/validatePin';
import sendPinForgot, { SendPinForgotAction } from './recoveryPassword/sendPin';
import changePassword, { ChangePasswordAction } from './recoveryPassword/changePassword';
import requestExtract, { RequestExtractAction } from './extract';
import requestRecharges, { RequestRechargesAction } from './extract/recharges';
import changePasswordAuth, { ChangePasswordAuthAction } from './password/change';
import updateData, { UpdateDataAction } from './auth/data/update';
import getCustomerData, { GetCustomerDataAction } from './auth/data/get';
import deleteVehicle, { DeleteVehicleAction } from './vehicles/delete';
import getVehicles, { GetVehiclesAction } from './vehicles/get';
import requestValues, { RequestValuesAction } from './recharge/values';
import rechargePix, { RechargePixAction } from './recharge/pix';
import rechargeSavedCard, { RechargeSavedCardAction } from './recharge/savedCard';
import rechargeCard, { RechargeCardAction } from './recharge/card';
import changePaymentMethod, { ChangePaymentMethodAction } from './recharge/changePaymentMethod';
import createVehicle, { CreateVehicleAction } from './vehicles/create';

export default function* rootSaga(): Generator<AllEffect<ForkEffect<never>>, unknown, unknown> {
  return yield all([
    takeLatest<SendPinAction>(Types.SEND_PIN, sendPin),
    takeLatest<ValidatePinAction>(Types.VALIDATE_PIN, validatePin),
    takeLatest<RequestDebtsAction>(Types.REQUEST_DEBTS, requestDebts),
    takeLatest<DebtsPullingAction>(Types.DEBTS_PULLING, debtsPulling),
    takeLatest<SearchAddressAction>(Types.SEARCH_ADDRESS, searchAddressByZipcode),
    takeLatest<PaymentCardAction>(Types.PAYMENT_CARD, paymentCard),
    takeLatest<PaymentPixAction>(Types.PAYMENT_PIX, paymentPix),
    takeLatest<AuthAction>(Types.AUTHORIZE, authorize),
    takeLatest<RequestTicketsAction>(CustomerTypes.REQUEST_TICKETS, requestTickets),
    takeLatest<RequestInvoiceAction>(CustomerTypes.REQUEST_INVOICE, requestInvoice),
    takeLatest<SendMessageAction>(Types.SEND_MESSAGE, sendMessage),
    takeLatest<AuthorizeAction>(CustomerTypes.AUTH, auth),
    takeLatest<RefreshAction>(CustomerTypes.REFRESH, refresh),
    takeLatest<GetDataAction>(CustomerTypes.GET_DATA, getData),
    takeLatest<SendPinRegisterDeviceAction>(CustomerTypes.SEND_PIN_REGISTER_DEVICE, sendPinRegisterDevice),
    takeLatest<ValidatePinRegisterDeviceAction>(CustomerTypes.VALIDATE_PIN_REGISTER_DEVICE, validatePinRegisterDevice),
    takeLatest<SendPinRegisterAction>(CustomerTypes.SEND_PIN_REGISTER, sendPinRegister),
    takeLatest<ValidatePinRegisterAction>(CustomerTypes.VALIDATE_PIN_REGISTER, validatePinRegister),
    takeLatest<SearchAddressActionAutomatic>(CustomerTypes.SEARCH_ADDRESS, searchAddressByZipcodeAutomatic),
    takeLatest<ValidatePlateAction>(CustomerTypes.VALIDATE_PLATE, validatePlate),
    takeLatest<RequestBrandsAction>(CustomerTypes.REQUEST_BRANDS, requestBrands),
    takeLatest<RequestCategoriesAction>(CustomerTypes.REQUEST_CATEGORIES, requestCategories),
    takeLatest<RequestModelsAction>(CustomerTypes.REQUEST_MODELS, requestModels),
    takeLatest<RequestYearsAction>(CustomerTypes.REQUEST_YEARS, requestYears),
    takeLatest<CreateUserAction>(CustomerTypes.CREATE_USER, createUser),
    takeLatest<CreateCredentialsAction>(CustomerTypes.CREATE_CREDENTIALS, createCredentials),
    takeLatest<SendPinForgotAction>(CustomerTypes.SEND_PIN_FORGOT, sendPinForgot),
    takeLatest<ValidatePinForgotAction>(CustomerTypes.VALIDATE_PIN_FORGOT, validatePinForgot),
    takeLatest<ChangePasswordAction>(CustomerTypes.CHANGE_PASSWORD, changePassword),
    takeLatest<RequestExtractAction>(CustomerTypes.REQUEST_EXTRACT, requestExtract),
    takeLatest<RequestRechargesAction>(CustomerTypes.REQUEST_RECHARGES, requestRecharges),
    takeLatest<ChangePasswordAuthAction>(CustomerTypes.CHANGE_PASSWORD_AUTH, changePasswordAuth),
    takeLatest<UpdateDataAction>(CustomerTypes.UPDATE_DATA, updateData),
    takeLatest<GetCustomerDataAction>(CustomerTypes.GET_CUSTOMER_DATA, getCustomerData),
    takeLatest<DeleteVehicleAction>(CustomerTypes.DELETE_VEHICLE, deleteVehicle),
    takeLatest<GetVehiclesAction>(CustomerTypes.GET_VEHICLES, getVehicles),
    takeLatest<RequestValuesAction>(CustomerTypes.REQUEST_VALUES, requestValues),
    takeLatest<RechargePixAction>(CustomerTypes.RECHARGE_PIX, rechargePix),
    takeLatest<RechargeSavedCardAction>(CustomerTypes.RECHARGE_SAVED_CARD, rechargeSavedCard),
    takeLatest<RechargeCardAction>(CustomerTypes.RECHARGE_CARD, rechargeCard),
    takeLatest<ChangePaymentMethodAction>(CustomerTypes.CHANGE_PAYMENT_METHOD, changePaymentMethod),
    takeLatest<CreateVehicleAction>(CustomerTypes.CREATE_VEHICLE, createVehicle),
  ]);
}
